import type { ReactNode } from 'react';

import type { StickyHeaderProps } from '../types';

/**
 * StickyHeader setting to fix header during scroll.
 *
 * @example
 * ```tsx
 * <DataTable.StickyHeader height="4rem" />
 * ```
 */
export const StickyHeader = (_props: StickyHeaderProps): ReactNode => {
  return null;
};

StickyHeader.displayName = 'DataTable.StickyHeader';
